import PropTypes from 'prop-types'
import React from 'react'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="logo">
      <span className="icon fa-lightbulb-o"></span>
    </div>
    <div className="content">
      <div className="inner">
        <h1>Inspiration</h1>
        <hr className="title-ruling" />
        <h2>Consolidated Consulting</h2>
        <br />
        <br />
        {/* <h3>A Women and Veteran Owned Business</h3> */}
        <p>Founded 2015</p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('icc')
            }}
          >
            Mission
          </button>
        </li>

        <li>
          <button
            onClick={() => {
              props.onOpenArticle('about')
            }}
          >
            Leadership
          </button>
        </li>

        <li>
          <button
            onClick={() => {
              props.onOpenArticle('services')
            }}
          >
            Services
          </button>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
